import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13ab1e76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "allBlockWidth" }
const _hoisted_2 = { class: "partners-files" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "partners-files__item-icon center" }
const _hoisted_5 = { class: "textHidden" }

import { FileType } from '@/types';
import { usePartnerProgramStore } from '@/store/modules/partnerProgram';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnersFilesModal',
  props: {
    showModal: { type: Boolean },
    partnerFiles: {},
    partnerProgramId: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const downloadFiles = async () => {
  await usePartnerProgramStore().downloadDocuments(props.partnerProgramId);
};

return (_ctx: any,_cache: any) => {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "show-modal": _ctx.showModal,
    title: "Материалы продаж",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnerFiles, (file) => {
            return (_openBlock(), _createElementBlock("a", {
              key: file.id,
              href: file.path,
              class: "partners-files__item"
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(file.name.split('.').pop()), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(file.name), 1)
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("div", { class: "flex flex-end mt--10" }, [
          _createElementVNode("button", {
            class: "gradient-color",
            onClick: downloadFiles
          }, "Скачать все")
        ])
      ])
    ]),
    _: 1
  }, 8, ["show-modal"]))
}
}

})